import { Button } from 'react-bootstrap';
import { IPAWS_AREA_TYPES } from '../../../../utils/ipawsArea.utils';

const ShapePlacementControls = ({
  activeTool,
  canDrawPolygon = true,
  canPlaceSquare = true,
  canPlaceCircle = true,
  onStartTool,
  ariaLabel = 'Add an alert area',
}) => (
  <div role="group" aria-label={ariaLabel} className="d-flex flex-column gap-1">
    <Button
      type="button"
      size="sm"
      variant="secondary"
      className={`map-tools-button ${activeTool === IPAWS_AREA_TYPES.POLYGON ? 'is-selected' : ''}`}
      aria-pressed={activeTool === IPAWS_AREA_TYPES.POLYGON}
      disabled={Boolean(activeTool) || !canDrawPolygon}
      onClick={() => onStartTool(IPAWS_AREA_TYPES.POLYGON)}
    >
      Draw polygon
    </Button>
    <Button
      type="button"
      size="sm"
      variant="secondary"
      className={`map-tools-button ${activeTool === IPAWS_AREA_TYPES.SQUARE ? 'is-selected' : ''}`}
      aria-pressed={activeTool === IPAWS_AREA_TYPES.SQUARE}
      disabled={Boolean(activeTool) || !canPlaceSquare}
      onClick={() => onStartTool(IPAWS_AREA_TYPES.SQUARE)}
    >
      Place square
    </Button>
    <Button
      type="button"
      size="sm"
      variant="secondary"
      className={`map-tools-button ${activeTool === IPAWS_AREA_TYPES.CIRCLE ? 'is-selected' : ''}`}
      aria-pressed={activeTool === IPAWS_AREA_TYPES.CIRCLE}
      disabled={Boolean(activeTool) || !canPlaceCircle}
      onClick={() => onStartTool(IPAWS_AREA_TYPES.CIRCLE)}
    >
      Place circle
    </Button>
  </div>
);

export default ShapePlacementControls;
